import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { Observable } from "rxjs";
import { AnchorEPIMSFacade } from "./../../../../../anchorepimsgates/src/lib/states/+anchorepimsgates/anchorepimsgates.facade";
import { documentUploadRequest } from "./../../../../../anchorepimsgates/src/lib/states/+anchorepimsgates/anchorepimsgates.actions";
import { DocumentDto } from "./../../../../../data/src/lib/dto/document.dto";
import { FormGroup, FormBuilder } from "@angular/forms";

import { Guid } from "guid-typescript";
import { viewerType } from "./document-viewer/document-viewer/document-viewer.component";

import { ImageViewerConfig, CustomImageEvent } from "angular-x-image-viewer";

import * as FileSaver from "file-saver";

import { ConnectionService } from "ng-connection-service";
import { StakeholderReferenceDto } from "@cradua/data";

import { StakeholderReferenceFacade } from "./../../../../../stakeholderreference/src/lib/states/+stakeholderreference/stakeholderreference.facade";

import * as XLSX from "xlsx";
import { HttpClient } from "@angular/common/http";
import { switchMap } from "rxjs/operators";

type AOA = any[][];

// declare var require: any
// const FileSaver = require('file-saver');
@Component({
  selector: "mrsoftapps-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.css"],
})
export class DocumentsComponent implements OnInit, OnChanges {
  @Input()
  OriginatingModule: string = "General";
  @Input()
  OriginatedModuleSpecificId: string = "Gen";
  @Input()
  SubmitIsTriggerByparent: boolean = false;

  // @Input() SubmitEventOutside:  new EventEmitter<string>();

  completed$: Observable<boolean>;
  progress$: Observable<number>;
  error$: Observable<string>;

  isInProgress$: Observable<boolean>;
  isReady$: Observable<boolean>;
  hasFailed$: Observable<boolean>;

  documentForm: FormGroup;
  documentId: string;
  showDocDescForm: boolean = false;
  file: File;
  selectedFileName: string = "";
  fileSize: string = "";
  fileType: string = "";
  myDocuments: any[] = [];
  myDocuments$: Observable<any>;
  selectedDocument: any;
  showList: boolean = true;
  showDoc: boolean = false;
  docType: string = "";
  fileExist: boolean = true;
  fileExistMsg: string = "";
  documentTypes: StakeholderReferenceDto[] = [];
  documentSecurities: StakeholderReferenceDto[] = [];
  documentPhysicalLocations: StakeholderReferenceDto[] = [];
  searchvalue: string;

  status = "ONLINE";
  isConnected = true;

  // Show Excel

  name = "Angular";
  fileName: string = "SheetJS.xlsx";
  data: any;
  headData: any; // excel row header

  images = [];
  testURL: string =
    "http://localhost:3333/api/epimsgates/document/e4e836f9bed12c1078adcc9aae9b7218d.docx";

  @ViewChild("fullScreen", { static: true })
  divRef: any;

  constructor(
    private epimsGateFacade: AnchorEPIMSFacade,
    private fb: FormBuilder,
    private connectionService: ConnectionService,
    private stakeholderreferenceFacade: StakeholderReferenceFacade,
    private http: HttpClient,
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
      } else {
        this.status = "OFFLINE";
      }
    });
  }

  ngOnInit() {
    this.initDocumentForm();
    console.log("Reaching Documents inits");

    this.completed$ = this.epimsGateFacade.completd();
    this.progress$ = this.epimsGateFacade.progress();

    this.error$ = this.epimsGateFacade.error();

    this.isInProgress$ = this.epimsGateFacade.isInProgress();

    this.isReady$ = this.epimsGateFacade.isReady();

    this.hasFailed$ = this.epimsGateFacade.hasFailed();
    //this.myDocuments$ = this.epimsGateFacade.loadEPIMSGate('Document');

    this.loadDocuments();
    this.loadAllRefData();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName) {
        // when your @Input value is changed
        if (propName === "OriginatedModuleSpecificId") {
          // update the component here

          this.loadDocuments();
        }

        if (propName === "SubmitIsTriggerByparent") {
          // update the component here

          // this.loadDocuments();

          console.log("Reaching Submit of Document ");

          this.OnSubmit();
        }
      }
    }
  }

  openFullscreen() {
    // Use this.divRef.nativeElement here to request fullscreen
    const elem = this.divRef.nativeElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  }

  loadAllRefData() {
    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference("DocumentType", undefined, undefined)
      .subscribe((data) => {
        if (this.documentTypes.length === 0) {
          this.documentTypes = data.filter((n) => n.Type === "DocumentType");
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference("DocumentSecurity", undefined, undefined)
      .subscribe((data) => {
        if (this.documentSecurities.length === 0) {
          this.documentSecurities = data.filter(
            (n) => n.Type === "DocumentSecurity",
          );
        }
      });

    this.stakeholderreferenceFacade
      .loadByTypeStakeholderReference(
        "DocumentPhysicalLocation",
        undefined,
        undefined,
      )
      .subscribe((data) => {
        if (this.documentPhysicalLocations.length === 0) {
          this.documentPhysicalLocations = data.filter(
            (n) => n.Type === "DocumentPhysicalLocation",
          );
        }
      });
  }

  loadDocuments() {
    console.log(
      "OriginatingModule  ",
      this.OriginatingModule,
      this.OriginatedModuleSpecificId,
    );
    this.myDocuments = [];
    this.epimsGateFacade.loadEPIMSGate("Document").subscribe(
      (data) => {
        if (data) {
          if (this.OriginatingModule === "General") {
            this.myDocuments = data;
          } else {
            if (this.OriginatedModuleSpecificId.length > 0) {
              this.myDocuments = data.filter(
                (n) =>
                  n.OriginatedModuleSpecificId ===
                    this.OriginatedModuleSpecificId,
              );
            }
          }
        }
      },
      (error) => {
        console.log("Got Data from EPIMS gate error ", error);
      },
    );
  }

  initDocumentForm() {
    this.documentId = Guid.create().toString();

    this.documentForm = this.fb.group({
      id: [this.documentId],
      DocumentId: [this.documentId],
      DocumentTitle: [""],

      DocumentNo: [""],
      DocumentURL: [""],
      DocumentStatus: [""],
      DocumentApprovalStatus: [""],
      DocumentPhysicalLocationId: [""],
      DocumentTypeId: [""],
      DocumentTypeCodeId: [""],
      DocumentIsPhysicallyFilled: [""],
      DocumentRefNo: [""],
      DocumentSecurityId: [""],
      DocumentSecurityClassification: [""],
      FilePath: [""],
      FileName: [""],
      FileType: [""],
      FileSize: [""],
      OriginatedDepartment: [""],
      DocumentMainRefNo: [""],
      OriginatedModule: [this.OriginatingModule],
      ShelveNo: [""],
      DocumentDescription: [""],
      SubscriberId: [""],
      SiteId: [""],
      OriginatedModuleSpecificId: [this.OriginatedModuleSpecificId],
      DocumentDate: ["2/2/1988"],
      DocumentDueDate: ["2/2/1988"],
      DocumentTags: [""],
      DocumentParentId: [""],
      FileUploadPath: [""],
    });
  }

  uploadFile(event: any) {
    this.initDocumentForm();
    const files: FileList = event.target.files;
    const file = files.item(0);

    this.file = file;

    let document: DocumentDto[] = [];

    this.selectedFileName = file.name;
    this.fileSize = Math.floor(file.size / 1000).toString() + " KB";
    //this.fileType = file.type.split('.')[1];
    this.fileType = file.type;

    // this.documentForm.value.FileName.setValue = file.name;
    this.documentForm.get("FileName").setValue(file.name.split(".")[0]);

    // let doc = new DocumentDto();

    // doc.DocumentTitle = "Testing Document Upload";
    // doc.DocumentDescription = "New Document posting for development";

    // document.push(doc);

    console.log("Selected File ", file);

    // clear the input form
    event.srcElement.value = null;

    this.showDocDescForm = true;
  }

  resetUpload() {
    this.epimsGateFacade.resetUpload();
  }

  cancelUpload() {
    this.epimsGateFacade.cancelUpload();
  }

  OnSubmit() {
    console.log("File with Document ", this.file);
    if (this.file !== undefined) {
      this.epimsGateFacade.uploadDocumentWithFile(
        "Document",
        this.file,
        this.documentForm.value,
      );
    } else {
      let deletedList = [];

      let dataToUpload: any[] = [];
      dataToUpload.push(this.documentForm.value);

      console.log("Reaching File Update without file", dataToUpload);
      this.epimsGateFacade.update(
        "Document",
        this.documentForm.value,
        deletedList,
      );
    }

    this.initDocumentForm();
    this.showDocDescForm = false;
    this.loadDocuments();
  }

  classifyChanged(event) {
    if (event.checked) {
      this.showDocDescForm = true;
    } else {
      this.showDocDescForm = false;
    }
  }

  addWithoutFile() {
    this.showDocDescForm = !this.showDocDescForm;
  }

  // tslint:disable-next-line: member-ordering
  viewers: {
    name: viewerType;
    docs: string[];
    custom: boolean;
    acceptedUploadTypes: string;
  }[] = [
    {
      name: "google",
      docs: [
        "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.docx",
        "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_10.xlsx",
        "https://file-examples.com/wp-content/uploads/2017/10/file_example_TIFF_1MB.tiff",
        "https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf",
        "https://file-examples.com/wp-content/uploads/2017/08/file_example_PPT_250kB.ppt",
      ],
      custom: true,
      acceptedUploadTypes: null,
    },
    {
      name: "office",
      docs: [
        "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.docx",
        "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_10.xlsx",
        "https://file-examples.com/wp-content/uploads/2017/10/file_example_TIFF_1MB.tiff",
        "https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf",
        "https://file-examples.com/wp-content/uploads/2017/08/file_example_PPT_250kB.ppt",
      ],
      custom: true,
      acceptedUploadTypes: null,
    },
    {
      name: "mammoth",
      docs: [`${window.location.href}/assets/file-sample_100kB.docx`],
      custom: false,
      acceptedUploadTypes:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    {
      name: "pdf",
      docs: [`${window.location.href}/assets/file-sample_150kB.pdf`],
      custom: false,
      acceptedUploadTypes: "application/pdf",
    },
  ];
  selectedViewer = this.viewers[0];
  selectedDoc = this.selectedViewer.docs[0];

  selectViewer(viewerName: viewerType) {
    if (viewerName !== this.selectViewer.name) {
      this.selectedViewer = this.viewers.find((v) => v.name === viewerName);
      this.selectedDoc = this.selectedViewer.docs[0];
    }
  }

  getDocExtension(doc: string) {
    const splittedDoc = doc.split(".");
    return splittedDoc[splittedDoc.length - 1];
  }

  handleFiles(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.selectedDoc = e.target.result;
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  imageIndexOne = 0;

  config: ImageViewerConfig = {
    customBtns: [
      { name: "print", icon: "fa fa-print" },
      { name: "link", icon: "fa fa-link" },
    ],
  };

  handleEvent(event: CustomImageEvent) {
    console.log(`${event.name} has been click on img ${event.imageIndex + 1}`);

    switch (event.name) {
      case "print":
        console.log("run print logic");
        break;
    }
  }

  showdocument(doc: any) {
    this.selectedDocument = doc;

    if (doc.FileType.includes("image")) {
      this.docType = "Image";
      this.images = [];
      this.images.push(doc.FileUploadPath);
    }

    if (doc.FileType.includes("application/pdf")) {
      this.docType = "pdf";
    }
    if (
      doc.FileType.includes(
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      )
    ) {
      this.docType = "mammoth";
    }

    if (
      doc.FileType.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      )
    ) {
      this.data = [];
      this.headData = [];

      this.docType = "Excel";

      this.http
        .get(doc.FileUploadPath, {
          responseType: "blob",
        })
        .subscribe((response) => {
          const reader: FileReader = new FileReader();
          // const binaryString = reader.readAsDataURL(base64ImageUrl);
          reader.readAsBinaryString(response);

          // console.log('string data ', binaryString);
          reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            this.data = <AOA> (
              XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })
            );
            console.log(this.data[1]);

            this.headData = this.data[0];

            console.log("Head Data ", this.data);
            this.data = this.data.slice(1); // remove first header record

            const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
            this.readDataSheet(ws2, 10);
          };

          //doc.FileUploadPath
          //reader.readAsBinaryString(blob);

          //  this.downLoadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        });
    }
    this.showDoc = true;
    this.showList = false;

    this.documentForm.patchValue(doc);
  }

  gobackToDocList() {
    this.showDoc = false;
    this.showList = true;
  }

  downloadSelectedDoc() {
    // const pdfUrl = './assets/sample.pdf';
    // const pdfName = 'your_pdf_file';
    FileSaver.saveAs(
      this.selectedDocument.FileUploadPath,
      this.selectedDocument.FileName.split(".")[0],
    );
  }

  downloadDoc(doc: any) {
    // const pdfUrl = './assets/sample.pdf';
    // const pdfName = 'your_pdf_file';
    FileSaver.saveAs(doc.FileUploadPath, doc.FileName.split(".")[0]);
  }

  doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", urlToFile, false);
    xhr.send();

    if (xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }

  doesFileExistwithURL() {
    let urlMain = this.documentForm.value.DocumentURL;

    if (urlMain.length === 0) {
      return;
    }
    var result = this.doesFileExist(urlMain);

    if (result == true) {
      // yay, file exists!

      console.log("Valid path");

      this.fileExist = true;
    } else {
      // file does not exist!
      console.log("InValid path");
      this.fileExist = false;
      this.fileExistMsg =
        "The Url supplied couldn't resolve to a file as a result of no internet connectivity or the url does not exist, please cross check or ignore to continue";
    }
  }

  searchDocuments() {}

  private readDataSheet(ws: XLSX.WorkSheet, startRow: number) {
    /* save data */
    let datas = <AOA> (
      XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: startRow })
    );
    console.log(datas[1]);
    let headDatas = datas[0];
    datas = datas.slice(1); // remove first header record

    for (let i = 0; i < this.data.length; i++) {
      this.data[i][this.headData.length] = datas.filter(
        (x) => x[12] == this.data[i][0],
      );
    }
    console.log(this.data[1]);
  }

  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  convertBlobToBase64(blob: Blob) {
    return Observable.create((observer) => {
      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(blob);

      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.data = <AOA> (
          XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })
        );
        console.log(this.data[1]);

        this.headData = this.data[0];

        console.log("Head Data ", this.data);
        this.data = this.data.slice(1); // remove first header record

        const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
        this.readDataSheet(ws2, 10);
      };

      //doc.FileUploadPath
      reader.readAsBinaryString(blob);
      // reader.onload = (event: any) => {
      //   console.log('Image in Base64: ', event.target.result);
      //   observer.next(event.target.result);
      //   observer.complete();
      // };

      reader.onerror = (event: any) => {
        console.log("File could not be read: " + event.target.error.code);
        observer.next(event.target.error.code);
        observer.complete();
      };
    });
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      alert("Please disable your Pop-up blocker and try again.");
    }
  }
}
